var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[(_vm.mainTheme == 'darkMode')?_c('img',{attrs:{"src":require("@/assets/logo-white.png"),"width":"220px"}}):_c('img',{attrs:{"src":require("@/assets/logo-black.png"),"width":"220px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }